/* @flow */
import type {Action} from "../action";

type RUB =  {
  symbol: string,
  rawSymbol: string,
  bids: number[],
  initialDeposit: number,
  minFillup: number,
  minWithdraw: number,
  vipPayment: number,
  minPayment: number,
  minBidAmount: number,
};

type CurrencySettings =  {
  RUB: RUB,
  USD: RUB,
  EUR: RUB,
  VND: RUB,
  HKD: RUB,
  PHP: RUB,
};

type En =  {
  email: string,
  phone: string[],
};

type MapLocation =  {
  lat: number,
  long: number,
};

type MaxBidVolume =  {
  USD: number,
  RUB: number,
  THB: number,
  VND: number,
  EUR: number,
  HKD: number,
  PHP: number,
};

type PhoneExamples =  {
  VN: string,
  HK: string,
  KR: string,
  PH: string,
  MY: string,
  IN: string,
};

type SupportInfo =  {
  en: En,
  ru: En,
  vn: En,
  ph: En,
};

export type ServerData = {
  isAndroidApp: boolean,
  websocketWebPort: string,
  websocketDomain: string,
  websocketSubdomain: string,
  geo: string,
  lang: string,
  currency: string,
  language: string,
  platform: string,
  app_platform_vendor: string,
  app_version: number,
  isMobile: boolean,
  isVIP: number,
  vipBadge: string,
  silverBadge: string,
  currency_settings: CurrencySettings,
  sterling: string,
  noBonuse: boolean,
  percent: number,
  ccPercent: number,
  percentKey: string,
  defaultValue: number,
  codeValue: number[],
  bPercents: number[],
  vipFrom: number,
  isIOS: boolean,
  maxUploadFileSize: number,
  projectTitle: string,
  countryLang: string,
  minFillup: string,
  maxBidVolume: MaxBidVolume,
  mapLocation: MapLocation,
  profileId: number,
  supportInfo: SupportInfo,
  supportEmail: string,
  supportPhone: string,
  tourGetReal: number,
  tourGetFundsAvailableReal: number,
  tourRegScenario: string,
  tourRefBonus: string,
  faqSymbol: string,
  faqMinDeposit: string,
  faqMinWithdraw: string,
  faqMinPayment: string,
  faqVipPayment: string,
  faqRefMaster: string,
  faqRefMindepo: string,
  faqGainPercent: number,
  phoneExamples: PhoneExamples,
};

export type State = ServerData | null;

function serverData(state: State = null, action: Action): State {
  switch (action.type) {
    case "RECEIVE_SERVER_DATA":
      return {...state, ...action.payload};
    default:
      return state;
  }
}

export default serverData;



// WEBPACK FOOTER //
// ./src/redux/reducer/serverData.js